import ReportsTransactionTableHeader from './ReportsTransactionTableHeader'

export default ReportsTransactionTableHeader
